module.exports = __webpack_public_path__ + "img/applicationresults_gj.f2011370.jpg";